import { apiService } from './api';

interface ErrorLogData {
  message: string;
  stack?: string;
  errorType?: string;
  url?: string;
  userAgent?: string;
  userId?: string;
  userEmail?: string;
  userRole?: string;
  component?: string;
  action?: string;
  additionalData?: Record<string, any>;
  browserInfo?: string;
  screenResolution?: string;
}

class ErrorLogger {
  private isLogging = false;

  async logError(error: Error | string, context?: {
    component?: string;
    action?: string;
    additionalData?: Record<string, any>;
  }): Promise<void> {
    // Infinite loop'u önle
    if (this.isLogging) {
      console.error('Error logging already in progress, skipping...');
      return;
    }

    try {
      this.isLogging = true;

      const errorMessage = typeof error === 'string' ? error : error.message;
      const errorStack = typeof error === 'string' ? undefined : error.stack;
      const errorType = typeof error === 'string' ? 'StringError' : error.constructor.name;

      // Kullanıcı bilgilerini al
      const userStr = localStorage.getItem('user');
      let userId: string | undefined;
      let userEmail: string | undefined;
      let userRole: string | undefined;

      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          userId = user.id?.toString();
          userEmail = user.email;
          userRole = user.role;
        } catch {
          // JSON parse hatası, devam et
        }
      }

      // Browser bilgilerini al
      const browserInfo = this.getBrowserInfo();
      const screenResolution = `${window.screen.width}x${window.screen.height}`;

      const logData: ErrorLogData = {
        message: errorMessage,
        stack: errorStack,
        errorType,
        url: window.location.href,
        userAgent: navigator.userAgent,
        userId,
        userEmail,
        userRole,
        component: context?.component,
        action: context?.action,
        additionalData: context?.additionalData,
        browserInfo,
        screenResolution,
      };

      // Backend'e log gönder
      await apiService.logFrontendError(logData);
    } catch (logError) {
      // Log gönderme hatası - console'a yaz
      console.error('Failed to log error to backend:', logError);
      console.error('Original error:', error);
    } finally {
      this.isLogging = false;
    }
  }

  private getBrowserInfo(): string {
    const ua = navigator.userAgent;
    let browser = 'Unknown';

    if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edg') === -1) {
      browser = 'Chrome';
    } else if (ua.indexOf('Firefox') > -1) {
      browser = 'Firefox';
    } else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
      browser = 'Safari';
    } else if (ua.indexOf('Edg') > -1) {
      browser = 'Edge';
    } else if (ua.indexOf('Opera') > -1 || ua.indexOf('OPR') > -1) {
      browser = 'Opera';
    }

    return browser;
  }
}

export const errorLogger = new ErrorLogger();

